import "./PageLoading.scss";

import * as React from "react";
import { LoadStatus, SaveStatus } from "common/loader/types";
import { Trigger } from "common/loader/Trigger";
import { useEffect } from "react";
import { PageLoading } from "core/components/pageLoading";

export interface PageLoadingDataProps {
    loadStatus: LoadStatus;
    saveStatus?: SaveStatus;
}

export type PageLoadingProps<T> =
    | ({ loadStatus: "loaded"; saveStatus?: SaveStatus } & PageLoadingActionProps & T)
    | ({ loadStatus: LoadStatus; saveStatus?: SaveStatus } & PageLoadingActionProps & Partial<T>);

export interface PageLoadingActionProps {
    fetch?: () => void;
}

export const withLoader =
    <P extends {}>(Component: React.ComponentType<P>, isFullPage?: boolean): React.FC<PageLoadingProps<P>> =>
    ({ loadStatus, saveStatus, fetch, ...props }: PageLoadingProps<P>) => {
        useEffect(() => {
            if (loadStatus === "unloaded") {
                fetch!();
            }
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [loadStatus]);

        return (
            <Trigger action={fetch!}>
                {loadStatus === "loaded" && <Component {...(props as any)} saveStatus={saveStatus} />}
                {loadStatus === "failed" && (
                    <div className={"p-5"} onClick={fetch}>
                        Failed
                    </div>
                )}
                {loadStatus === "loading" && (
                    <div className="loader__container loader__container--overlay">
                        <PageLoading background="auto" />
                    </div>
                )}
            </Trigger>
        );
    };
